import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import styles from './_cityRoutes.css'
import { FormattedMessage } from 'react-intl'
import { Heading } from 'components/util'
import SearchCityStateForm from './SearchCityStateForm'
import { Cities } from 'components/util'
import { selectIsMobile } from 'services/viewport/selectors'
import * as routeActions from 'services/routes/actions'
import * as eventActions from 'services/events/actions'

const mapStateToProps = (state) => ({
  isMobile: selectIsMobile(state),
})

const mapDispatchToActions = {
  ...eventActions,
  ...routeActions,
}

export class CityRoutes extends Component {

  static propTypes = {
    isMobile: PropTypes.bool,
    searchCityLogEvent: PropTypes.func,
    buttonClickedEvent: PropTypes.func,
    linkClickedEvent: PropTypes.func,
  }

  handleSearchCitySubmit = ({ city }) => {
    const { searchCityLogEvent, buttonClickedEvent } = this.props
    searchCityLogEvent(city)
    buttonClickedEvent('Go', city)
    window.location.href = city
  }

  render () {
    const headingStyles = {
      color: 'white',
      align: 'center',
      barWidth: '64px',
      tabletFontSize: '32px',
      mobileFontSize: '32px',
      letterSpacing: '2px',
    }
    const { isMobile, buttonClickedEvent, linkClickedEvent } = this.props
    return (
      <div className={styles.cityRoutes}>
        <Heading {...headingStyles} bottomBar={true} headingClassName={styles.heading}>
          <FormattedMessage id='route.landing.explorecityRrutes'
            defaultMessage='Explore City Routes' />
        </Heading>
        <SearchCityStateForm onSubmit={this.handleSearchCitySubmit} />
        <Cities margin={isMobile ? '42px auto' : '54px auto'}
          numberOfColumns={isMobile ? 2 : 3}
          logEvent={linkClickedEvent} />
        <div className={styles.viewAllCitiesContainer}>
          <div className={styles.viewAllCitiesBtn}>
            <a href='/us/' onClick={() => buttonClickedEvent('View All Cities', '/us/')}>
              <FormattedMessage
                id='route.landing.viewallcities'
                defaultMessage='View All Cities' />
            </a>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToActions)(CityRoutes)
